import { render, staticRenderFns } from "./cartabs.vue?vue&type=template&id=427f4436&"
import script from "./cartabs.vue?vue&type=script&lang=js&"
export * from "./cartabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports